import { Mutations } from "@/utils/constants/types.js";

const localeKey = "locale";

export default store => {
  const locale = localStorage.getItem(localeKey);

  if (locale !== null) {
    store.commit(Mutations.SET_LOCALE, locale);
  }

  store.subscribe(mutation => {
    if (mutation.type === Mutations.SET_LOCALE) {
      localStorage.setItem(localeKey, mutation.payload);
    }
  });
};
